import { getCookieValueByKey } from "@helpers/Cookie";
import { getParameterByName } from "@helpers/QueryString";

const getOptimizelyUidOverride = () => {
  const value = getParameterByName("dyh-opt-uid");
  if (value) {
    console.log(`%cForced Optimizely UID: ${value}`, "color: #fbd911");
    return value;
  }
  return false;
};

const getAnalyticsId = () =>
  getOptimizelyUidOverride() ||
  getCookieValueByKey("_ga") ||
  process.env.GATSBY_LOCAL_DEBUG_OVERRIDE_OPTIMIZELY_USER_ID;

export default getAnalyticsId;
